import { OverallEffectiveness } from '../../../types/API'

export function showBBOverallEffectivenessOption (overallEffectivenessConfig?: OverallEffectiveness | null): boolean {
  if (!overallEffectivenessConfig) {
    return false
  }
  return !!overallEffectivenessConfig.system
}

export function showUniverseOverallEffectivenessOption (overallEffectivenessConfig?: OverallEffectiveness | null): boolean {
  if (!overallEffectivenessConfig) {
    return false
  }
  return !!overallEffectivenessConfig.universe
}

export function showOverallEffectiveness (overallEffectivenessConfig?: OverallEffectiveness | null): boolean {
  if (!overallEffectivenessConfig) {
    return false
  }
  return showBBOverallEffectivenessOption(overallEffectivenessConfig) || showUniverseOverallEffectivenessOption(overallEffectivenessConfig)
}
